import { render, staticRenderFns } from "./AddTenantsExel.vue?vue&type=template&id=82798906&scoped=true"
import script from "./AddTenantsExel.vue?vue&type=script&lang=js"
export * from "./AddTenantsExel.vue?vue&type=script&lang=js"
import style0 from "./AddTenantsExel.vue?vue&type=style&index=0&id=82798906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82798906",
  null
  
)

export default component.exports